export enum UnsubscribePageScreen {
    Default = 'default',
    Email = 'email',
    Topics = 'topics',
}
